export default __webpack_public_path__ + "static/featured-blog-2-559f9076e6ea23f8b1738380f0ef82c1.png";